import type { FC } from "react";
import { Container } from "@/ui/components/layout";
import { Illustration } from "@/ui/components/primitives";
import { Logo } from "@/ui/components/primitives/Logo/Logo";
import {
  NewsletterSignup,
} from "@/ui/components/sections/marketing/NewsletterSignUp";
import { cn } from "@/ui/lib";
import * as FooterConfig from "./Footer.config";
import type { TFooterProps } from "./Footer.config";
import { FooterCountryToggle } from "./FooterCountryToggle";
import { FooterPrimaryNavigationList } from "./FooterPrimaryNavigationList";
import { FooterSecondaryNavigationList } from "./FooterSecondaryNavigationList";
import { FooterSocialNavigation } from "./FooterSocialNavigation";

export const Footer: FC<TFooterProps> = ({
  "data-component": component = FooterConfig.FOOTER_DEFAULTS["data-component"],
  primaryNavigation,
  secondaryNavigation,
  socialNavigation,
  newsletter,
  isSignedIn = false,
  countryToggle = <FooterCountryToggle />,
  className,
  ...props
}) => {
  const newsletterProps = newsletter ?? FooterConfig.FOOTER_DEFAULT_NEWSLETTER_PROPS;
  const showNewsletter = !isSignedIn && newsletter !== null;

  return (
    <footer
      {...props}
      data-component={component}
      className={cn(
        "overflow-hidden bg-inverse text-sys-white",
        className,
      )}
    >
      <Container className={FooterConfig.FOOTER_MAIN_CONTAINER_CLASS_NAME}>
        { showNewsletter && (
          <>
            <Illustration
              illustration="hangingCat"
              className={FooterConfig.FOOTER_HANGING_CAT_CLASS_NAME}
            />
            <NewsletterSignup
              {...newsletterProps}
              className={cn(
                "md:w-[299px] lg:w-[478px]",
                newsletterProps.className,
              )}
            />
          </>
        ) }
        <FooterPrimaryNavigationList sections={primaryNavigation} />
        <FooterSocialNavigation links={socialNavigation} />
      </Container>
      <div className={FooterConfig.FOOTER_COUNTRY_TOGGLE_WRAPPER_CLASS_NAME}>
        { countryToggle }
      </div>
      <Logo className="text-sys-neutral-600" />
      <FooterSecondaryNavigationList
        links={secondaryNavigation}
      />
    </footer>
  );
};

Footer.displayName = "Footer";
